import { render, staticRenderFns } from "./MasterPropertyDialog.vue?vue&type=template&id=4f0b694b&scoped=true&"
import script from "./MasterPropertyDialog.vue?vue&type=script&lang=js&"
export * from "./MasterPropertyDialog.vue?vue&type=script&lang=js&"
import style0 from "./MasterPropertyDialog.vue?vue&type=style&index=0&id=4f0b694b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b694b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VDialog,VForm,VRow,VSpacer,VToolbar})
